export default __webpack_public_path__ + "static/media/emmy.e4ebb69d.bin";